import { makeStyles } from '@material-ui/styles';

export default makeStyles(theme => ({
  container: {
    border: [1, 'solid', theme.palette.colors.border],
    padding: [0, theme.spacing(3)],
    width: '100%',
    height: 188,
    position: 'relative',
    borderRadius: 3,
    marginBottom: theme.spacing(2),
    [theme.breakpoints.up('mobile')]: {
      width: 360,
      marginRight: theme.spacing(4),
    },
  },
  disabled: {
    backgroundColor: theme.palette.colors.lightGray,
  },
  topBar: {
    display: 'flex',
    alignItems: 'center',
    width: '100%',
    height: '50%',
    borderBottom: [1, 'solid', theme.palette.colors.divider],
  },
  loanOfficerBadge: {
    display: 'flex',
    justifyContent: 'center',
    flexDirection: 'column',
    width: 150,
    marginLeft: theme.spacing(2),
  },
  name: {
    marginTop: 4,
  },
  label: {
    marginTop: 4,
  },
  companyLogo: {
    height: 30,
    width: 'auto',
    maxWidth: 100,
    marginLeft: theme.spacing(2),
  },
  bottomBar: {
    height: '50%',
    display: 'flex',
    alignItems: 'center',
    width: '100%',
  },
  infoBox: {
    width: 120,
  },
  removeButton: {
    position: 'absolute',
    top: 0,
    zIndex: 100,
    right: 0,
    [theme.breakpoints.up('mobile')]: {
      right: -35,
    },
  },
}));



// WEBPACK FOOTER //
// ./src/components/RealEstateAgentLoanOfficers/components/FavoriteLoanOfficersList/components/LoanOfficerCard/useStyles.js